module.exports = __webpack_public_path__ + "img/edge_patrimoine_art_contemporain.f34f30c5.svg";